import { Box, Skeleton, Stack } from '@mui/material';

const SKELETON_ROWS = 7;

export default function GlobalSearchSkeleton() {
  return (
    <Stack spacing={2} sx={{ px: 2, py: 2 }} id="global-search-skeleton">
      {Array.from({ length: SKELETON_ROWS }).map((_, idx) => (
        <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="80%" height={24} />
            <Skeleton variant="text" width="40%" height={18} />
          </Box>
        </Box>
      ))}
    </Stack>
  );
}
